import { render, staticRenderFns } from "./screenTable.vue?vue&type=template&id=5b5d395d&scoped=true"
import script from "./screenTable.vue?vue&type=script&lang=js"
export * from "./screenTable.vue?vue&type=script&lang=js"
import style0 from "./screenTable.vue?vue&type=style&index=0&id=5b5d395d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5d395d",
  null
  
)

export default component.exports